var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-good-table',{attrs:{"mode":"remote","totalRows":_vm.totalRecords,"isLoading":_vm.isLoading,"pagination-options":{
			enabled: true,
		},"rows":_vm.rows,"columns":_vm.columns,"search-options":{
			enabled: true,
			trigger: 'enter',
		},"line-numbers":true},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange,"update:isLoading":function($event){_vm.isLoading=$event},"update:is-loading":function($event){_vm.isLoading=$event},"on-row-click":_vm.onRowClick,"on-search":_vm.onSearch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }